import { render, staticRenderFns } from "./modal-scrollable-body.vue?vue&type=template&id=0aaa0e87&scoped=true"
import script from "./modal-scrollable-body.vue?vue&type=script&setup=true&lang=ts"
export * from "./modal-scrollable-body.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./modal-scrollable-body.vue?vue&type=style&index=0&id=0aaa0e87&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aaa0e87",
  null
  
)

export default component.exports